<template>
  <section class="revolution-section">
    <div class="marquee-container marquee-top">
      <div class="marquee-content">
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
      </div>
    </div>
    
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="revolution-content">
            <h2 class="revolution-title">
              La révolution des transferts vers l'Afrique, simples et 
              <span class="underlined-word">
                accessibles à tous
                <svg class="curved-underline" viewBox="0 0 240 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 8 Q120 2, 238 8" stroke="#F5A847" stroke-width="3" stroke-linecap="round"/>
                </svg>
              </span>
            </h2>
            <p class="revolution-description">
              Avec Nolido, que vous soyez en France, au Canada ou ailleurs, 
              envoyer de l'argent ou payer des factures à travers le monde en 
              quelques clics, sans contrainte de devise locale, grâce à notre 
              partenariat bancaire et à notre solution technique innovante
            </p>
            <CustomButton
              label="Télécharger l'App" 
              @click="handleDownload"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="revolution-image-container">
            <img :src="require('@/assets/img/Container (4).png')" alt="App mobile" class="phone-revolution">
            <div class="decorative-element-1"></div>
            <div class="decorative-element-2"></div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="marquee-container marquee-bottom">
      <div class="marquee-content">
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
        <span class="marquee-text">Transferts internationaux pour tous</span>
        <span class="marquee-dot">•</span>
      </div>
    </div>
  </section>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';

export default {
  name: "RevolutionSection",
  components: {
    CustomButton
  },
  methods: {
    handleDownload() {
      // Logique de téléchargement de l'app
      window.open('#', '_blank');
    }
  }
};
</script>

<style scoped>
.revolution-section {
  background: #FFF9F0;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.marquee-container {
  background: white;
  padding: 1rem 0;
  overflow: hidden;
  border-top: 1px solid #E5E5E5;
  border-bottom: 1px solid #E5E5E5;
}

.marquee-top {
  margin-bottom: 4rem;
}

.marquee-bottom {
  margin-top: 4rem;
}

.container {
  padding: 80px 15px;
}

.marquee-content {
  display: flex;
  align-items: center;
  gap: 2rem;
  animation: marquee 30s linear infinite;
  white-space: nowrap;
  width: max-content;
}

.marquee-text {
  font-size: 0.95rem;
  color: #666;
  font-weight: 500;
}

.marquee-dot {
  color: #F5A847;
  font-size: 1.2rem;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-25%);
  }
}

.revolution-content {
  padding: 2rem;
  padding-right: 3rem;
}

.revolution-title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #1A1A1A;
  line-height: 1.15;
  margin-bottom: 1.5rem;
  letter-spacing: -0.03em;
}

.underlined-word {
  position: relative;
  display: inline-block;
  white-space: nowrap;
}

.curved-underline {
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 105%;
  height: 12px;
  pointer-events: none;
}

.revolution-description {
  font-size: 1.05rem;
  color: #4A4A4A;
  line-height: 1.65;
  margin-bottom: 2rem;
  font-weight: 400;
}

.revolution-image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  min-height: 500px;
}

.phone-revolution {
  width: 100%;
  max-width: 380px;
  height: auto;
  position: relative;
  z-index: 2;
  object-fit: contain;
}

.decorative-element-1 {
  position: absolute;
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #FFE5C1 0%, #FFF 100%);
  border-radius: 50%;
  top: 10%;
  right: 10%;
  z-index: 1;
  opacity: 0.5;
}

.decorative-element-2 {
  position: absolute;
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #F5A847 0%, #FFC97D 100%);
  border-radius: 50%;
  bottom: 15%;
  left: 5%;
  z-index: 1;
  opacity: 0.3;
}

@media (max-width: 992px) {
  .container {
    padding: 60px 15px;
  }

  .revolution-title {
    font-size: 2rem;
  }

  .revolution-content {
    padding: 2rem;
  }

  .phone-revolution {
    max-width: 320px;
  }

  .revolution-image-container {
    min-height: 400px;
    margin-top: 2rem;
  }
  
  .marquee-top {
    margin-bottom: 3rem;
  }

  .marquee-bottom {
    margin-top: 3rem;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 40px 15px;
  }

  .revolution-content {
    padding: 1rem;
    text-align: center;
  }

  .revolution-title {
    font-size: 1.75rem;
  }

  .revolution-description {
    font-size: 0.95rem;
  }

  .marquee-text {
    font-size: 0.85rem;
  }

  .phone-revolution {
    max-width: 280px;
  }

  .decorative-element-1,
  .decorative-element-2 {
    display: none;
  }
  
  .marquee-top {
    margin-bottom: 2rem;
  }

  .marquee-bottom {
    margin-top: 2rem;
  }
}
</style>
